<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card v-if="url">
            <div class="common-text text-center mb-6">
                <slot name="deleteTitle"></slot>
            </div>
            <div class="main-text text-center mb-6">
                <slot name="deleteSubtitle"></slot>
            </div>
            <v-flex class="d-flex justify-end">
                <v-btn class="btn-grey main-text" @click="cancel">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="callDelete">
                    {{submitTitle}}
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalDeleteConfirm",
    props: {
        value: {
            type: Boolean,
        },
        url: {
            type: String,
        },
        close: {
            type: Function,
            default: () => {},
        },
        update: {
            type: Function,
            default: () => {},
        },
        submitTitle: {
            type: String,
            default: "Удалить",
        },
        param: {
            type: [Object, String],
        },
    },
    data() {
        return {
            dialog: false,
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.dialog = false;
            if (this.close) {
                this.close();
            }
            this.$emit('input', false);
        },
        callDelete() {
            this.$http.delete(this.url)
                .then(() => {
                    if (this.update) {
                        this.update(this.param);
                    }
                    this.cancel();
                })
                .catch((error) => {
                    console.log(error);
                    this.cancel();
                });
        },
    }

}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 125px;
}
</style>